import {
  EditTabLogo,
  ThemeTabLogo,
  PreviewTabLogo,
  UserManagementTabLogo,
  UserShareLogo,
  UploadTabLogo,
  DashboardTabLogo,
  PlaygroundTabLogo,
  MultiQuestionPlaygroundLogo,
  ContentAnalysisTabLogo,
  ReportingLogo,
  ClientManagementLogo,
  MyUsageLogo,
  ClientsUsageLogo,
  VisualizeLogicTabLogo,
} from './icon';
import {
  FormLogo,
  AnalysisLogo,
  AIBuilder,
  Quota,
  TransDash,
  ReelLogo,
  ReportDash,
  ArchiveIcon,
  ViewFormLogo,
} from '../Dashboard/Icons';
import { BillingIcon } from '../Common/Icons';
import SettingsIcon from '../Survey/SettingsIcon';
import { SidebarProps } from '.';
import {
  ContentWritingIcon,
  Flowchart02Icon,
  PaintBoardIcon,
  ComputerIcon,
  Share08Icon,
  AccountSetting02Icon,
  AnalysisTextLinkIcon,
  Robot01Icon,
  Book02Icon,
  WorkflowSquare05Icon,
  ReplayIcon,
  DashboardBrowsingIcon,
  PieChartIcon,
  UserStoryIcon,
  ManagerIcon,
  Upload05Icon,
  GoogleSheetIcon,
  PropertySearchIcon,
  AiContentGenerator01Icon,
  ProfileIcon,
  Settings01Icon,
  Archive03Icon,
  MegaphoneIcon,
  PencilEdit02Icon,
} from '@hugeicons/core-free-icons';

export type TabType = {
  id: string;
  text: string;
  Icon: any;
  permission: string;
  route: (tabId: string, surveyId: string) => string;
  beta?: boolean;
};

export const dynamicRouteSurvey = (tabId: string, surveyId: string) =>
  `/survey/?tabId=${tabId}&id=${surveyId}`;

export const dynamicRouteDashboard = (tabId: string, surveyId: string) =>
  `/dashboard/?tabId=${tabId}&id=${surveyId}`;

export const dynamicRouteLongformat = (tabId: string, surveyId: string) =>
  `/longformat/?tabId=${tabId}&id=${surveyId}`;

export const dynamicRouteReporting = (tabId: string, surveyId: string) =>
  `/templates/?tabId=${tabId}&id=${surveyId}`;

export const dynamicRouteUsage = (tabId: string) => `/usage/?tabId=${tabId}`;

export const dynamicRouteSettings = (tabId: string, surveyId: string) =>
  `/settings/?tabId=${tabId}`;

export const SurveyTabs = [
  {
    id: 'edit',
    text: 'Edit',
    Icon: ContentWritingIcon,
    permission: 'show_edit_survey',
    route: (tabId: string, surveyId: string) =>
      dynamicRouteSurvey(tabId, surveyId),
  },
  {
    id: 'visualizeLogic',
    text: 'Visualize Logic',
    Icon: Flowchart02Icon,
    permission: 'visualizeLogic',
    route: (tabId: string, surveyId: string) =>
      dynamicRouteSurvey(tabId, surveyId),
  },
  {
    id: 'theme',
    text: 'Design',
    Icon: PaintBoardIcon,
    permission: 'show_theme',
    route: (tabId: string, surveyId: string) =>
      dynamicRouteSurvey(tabId, surveyId),
  },
  {
    id: 'preview',
    text: 'Preview',
    Icon: ComputerIcon,
    permission: 'show_preview',
    route: (tabId: string, surveyId: string) =>
      dynamicRouteSurvey(tabId, surveyId),
  },
  {
    id: 'user',
    text: 'Share',
    Icon: Share08Icon,
    permission: 'show_share_survey',
    route: (tabId: string, surveyId: string) =>
      dynamicRouteSurvey(tabId, surveyId),
  },
  {
    id: 'setting',
    text: 'Team',
    Icon: AccountSetting02Icon,
    permission: 'show_user_management',
    route: (tabId: string, surveyId: string) =>
      dynamicRouteSurvey(tabId, surveyId),
  },
];

export const LongFormatTabs: TabType[] = [
  // {
  //   id: 'upload',
  //   text: 'Upload',
  //   Icon: (color: string) => <UploadTabLogo color={color} />,
  //   permission: 'upload',
  //   route: (tabId: string, surveyId: string) =>
  //     dynamicRouteLongformat(tabId, surveyId),
  // },
  {
    id: 'analysis',
    text: 'Media Analysis',
    Icon: AnalysisTextLinkIcon,
    permission: 'analysis',
    route: (tabId: string, surveyId: string) =>
      dynamicRouteLongformat(tabId, surveyId),
  },
  {
    id: 'playground',
    text: 'Playground',
    Icon: Robot01Icon,
    permission: 'playground',
    route: (tabId: string, surveyId: string) =>
      dynamicRouteLongformat(tabId, surveyId),
  },
  {
    id: 'content-analysis',
    text: 'Content Analysis',
    Icon: Book02Icon,
    permission: 'content_analysis',
    route: (tabId: string, surveyId: string) =>
      dynamicRouteLongformat(tabId, surveyId),
  },
  {
    id: 'dashboard',
    text: 'Universal Themes',
    Icon: WorkflowSquare05Icon,
    permission: 'dashboard',
    route: (tabId: string, surveyId: string) =>
      dynamicRouteLongformat(tabId, surveyId),
  },
  {
    id: 'reels',
    text: 'Reel Player',
    Icon: ReplayIcon,
    permission: 'reels',
    route: (tabId: string, surveyId: string) =>
      dynamicRouteLongformat(tabId, surveyId),
  },
  {
    id: 'report',
    text: 'Report',
    Icon: DashboardBrowsingIcon,
    permission: 'report',
    route: (tabId: string, surveyId: string) =>
      dynamicRouteLongformat(tabId, surveyId),
  },
  {
    id: 'setting',
    text: 'Team',
    Icon: AccountSetting02Icon,
    permission: 'show_user_management',
    route: (tabId: string, surveyId: string) =>
      dynamicRouteLongformat(tabId, surveyId),
  },
];

export const UsageTabs: TabType[] = [
  {
    id: 'my-usage',
    text: 'My Usage',
    Icon: PieChartIcon,
    permission: '',
    route: (tabId: string) => dynamicRouteUsage(tabId),
  },
  {
    id: 'clients-data',
    text: 'Org Usage',
    Icon: UserStoryIcon,
    permission: '',
    route: (tabId: string) => dynamicRouteUsage(tabId),
  },
  {
    id: 'client-management',
    text: 'Org Manage ment',
    Icon: ManagerIcon,
    permission: '',
    route: (tabId: string) => dynamicRouteUsage(tabId),
  },
];

export const ReportingTabs: TabType[] = [
  {
    id: 'report',
    text: 'Report',
    Icon: DashboardBrowsingIcon,
    permission: 'report',
    route: (tabId: string, surveyId: string) =>
      dynamicRouteReporting(tabId, surveyId),
  },
  {
    id: 'share',
    text: 'Share',
    Icon: Share08Icon,
    permission: 'share',
    route: (tabId: string, surveyId: string) =>
      dynamicRouteReporting(tabId, surveyId),
  },
];

export const FORM_TAB = 'form';
export const VIEW_FORM_TAB = 'view-form';
export const TRANSCRIPTION_TAB = 'transcription-dashboard';
export const ANALYSIS_TAB = 'analysis';
export const REPORTING_TAB = 'reporting';
export const REELS_TAB = 'reels';
export const QUOTA_TAB = 'dashboard';
export const UPLOAD_TAB = 'upload';
export const PLAYGROUND_TAB = 'playground';

export const SETTINGS_TAB = 'settings';
export const ARCHIVE_TAB = 'archive';

export const DashboardTabs = [
  {
    id: UPLOAD_TAB,
    text: 'Upload',
    Icon: Upload05Icon,
    permission: 'excel_upload',
    route: (tabId: string, surveyId: string) =>
      dynamicRouteDashboard(tabId, surveyId),
  },
  {
    id: FORM_TAB,
    text: 'Data',
    Icon: GoogleSheetIcon,
    permission: 'show_form',
    route: (tabId: string, surveyId: string) =>
      dynamicRouteDashboard(tabId, surveyId),
  },
  {
    id: VIEW_FORM_TAB,
    text: 'Data Tracker',
    Icon: PropertySearchIcon,
    permission: 'show_form',
    route: (tabId: string, surveyId: string) =>
      dynamicRouteDashboard(tabId, surveyId),
  },
  // {
  //   id: 'ai-builder',
  //   text: 'AI Builder',
  //   Icon: (color: string) => <AIBuilder color={color} />,
  //   permission: 'show_ai_analysis',
  //   route: (tabId: string, surveyId: string) =>
  //     dynamicRouteDashboard(tabId, surveyId),
  // },
  // {
  //   id: TRANSCRIPTION_TAB,
  //   text: 'Transcription',
  //   Icon: AiContentGenerator01Icon,
  //   permission: 'show_transcript',
  //   route: (tabId: string, surveyId: string) =>
  //     dynamicRouteDashboard(tabId, surveyId),
  // },
  {
    id: ANALYSIS_TAB,
    text: 'Analysis',
    Icon: AnalysisTextLinkIcon,
    permission: 'show_analysis',
    route: (tabId: string, surveyId: string) =>
      dynamicRouteDashboard(tabId, surveyId),
  },
  {
    id: PLAYGROUND_TAB,
    text: 'Playground',
    Icon: Robot01Icon,
    permission: 'show_multi_playground',
    route: (tabId: string, surveyId: string) =>
      dynamicRouteDashboard(tabId, surveyId),
    beta: true,
  },
  {
    id: REELS_TAB,
    text: 'Reels Player',
    Icon: ReplayIcon,
    permission: 'show_reels',
    route: (tabId: string, surveyId: string) =>
      dynamicRouteDashboard(tabId, surveyId),
  },
  {
    id: REPORTING_TAB,
    text: 'Reporting',
    Icon: DashboardBrowsingIcon,
    permission: 'show_reports',
    route: (tabId: string, surveyId: string) =>
      dynamicRouteDashboard(tabId, surveyId),
  },
  {
    id: QUOTA_TAB,
    text: 'Quota',
    Icon: ProfileIcon,
    permission: 'show_quota_dashboard',
    route: (tabId: string, surveyId: string) =>
      dynamicRouteDashboard(tabId, surveyId),
  },
];

export const SettingTabs = [
  {
    id: SETTINGS_TAB,
    text: 'Settings',
    permission: '',
    Icon: Settings01Icon,
    // route: () => 'settings',
    route: (tabId: string, surveyId: string) =>
      dynamicRouteSettings(tabId, surveyId),
  },
  {
    id: ARCHIVE_TAB,
    text: 'Archive',
    permission: '',
    Icon: Archive03Icon,
    route: (tabId: string, surveyId: string) =>
      dynamicRouteSettings(tabId, surveyId),
  },
  // {
  //   id: '/billing',
  //   text: 'Billings',
  //   permission: '',
  //   Icon: (color: string) => (
  //     <BillingIcon width={20} height={20} color={color} />
  //   ),
  //   route: () => 'billing',
  // },
];

export const WhatsNewTabs: TabType[] = [
  {
    id: 'whats-new',
    text: 'View Features',
    permission: '',
    Icon: MegaphoneIcon,
    route: () => '/whats-new',
  },
  {
    id: 'manage-features',
    text: 'Add / Edit',
    permission: 'admin_features',
    Icon: PencilEdit02Icon,
    route: () => '/whats-new?tab=manage',
  },
];
